module.exports = __webpack_public_path__ + "f015a83b.png";